import { useEffect, useState } from 'react';
import { _getToken } from 'utils/cookie-token';

function useLogged() {
  const [isLogged, setIsLogged] = useState(null);

  useEffect(() => {
    setIsLogged(!!_getToken());
  }, []);

  return isLogged;
}

export default useLogged;
